/* eslint-disable max-lines */
import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { PageContext, KView, KText, KImage, KDraggableScrollView } from '@/component/RtlLayout';
import { $k18n } from '@/common/i18n';
import { currentCountryWithoutEars, CountryNameList, getQuery, getQuerys, deviceId, userId, currentCountry } from '@/common/const';
import { convertStyles } from '@kibt/krn-utils';
import yoda from '@kibt/bridge';
import { getBottomBenfitParams, detailPubsub, useExtParamsObject, useGetSellerParams } from './utils';
import SwiperLineV2 from './components/SwiperLineV2';
import SpecLinePopV2 from './components/SpecLinePopV2';
import CouponLinePop from './components/CouponLinePop';
import OptionBar from './components/OptionBar';
import DetailSke from './components/DetailSke';
import RenderDetail from './components/RenderDetail';
import { getDetailData, postAddToCart, getCouponPopData } from '../api';
import { getAllLinkTrace, setPageDataTrace } from '@/common/utils/pageTrace';
import { radar } from '@/common/log';
import imgEmpty from '@/assets/images/empty.png';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';
import { logShowPageErr } from '../logger2.0';
import { isHalfByBridgeAsync, isInApp, isIOS, isAndroid, appVersion, isWeb, getHalfByQuery } from '@/common/device-info';
import { useEntranceType } from './const';
import { useConstructor } from '@/hooks/useLifecycle';
import { useNextTick } from '@/hooks/useNextTick';
import { useCheckMediaSource } from '@/common/hooks';
import { Toast } from '@kibt/meta-ui-krn';
import { useABHandler } from '../useABHandler';
import { useShowProductBenifits } from '@/hooks/abTest/useShowProductBenifits';
import { scaleW, vw } from '@/common/style';
import { DetailPageDataProvider, useDetailPageStore } from '@/page/detail/store';
import { useSetDetailBuyNum } from './hooks/useShowStepper';
import DeliveryLineV2 from './components/DeliveryLineV2';
import PriceLineV2 from './components/PriceLineV2';
import { resolvePv } from '@/common/utils/afterPv';
import { allowDefaultOutsideClick, ignoreOutsideClick, onClickContainerOutside } from '@/common/utils/clickOnContinerOutSide';
import { useDebounceFn, useMemoizedFn, useUnmount } from 'ahooks';
import { UseCoudanInfoProvider } from './components/Coudan/coudanInfoStore';
import { StyleSheet, View } from 'react-native';
import { firstAPI, firstScreen, whiteScreen } from '@/common/performance';
import SrcStyles from './index.styl';
const Styles = convertStyles(SrcStyles);
import { usePerfLog } from './hooks/usePerfLog';
import CommentLine from './components/CommentLine';
import BuyerGalleryLine from './components/BuyerGalleryLine';
import { useQuery, useQuerys } from '@/hooks/useQuery';
import { useRetrievalInfo } from '@/page/orderConfirm/views/util';
import { RootSiblingParent } from 'react-native-root-siblings';
import { SCENE } from '@/common/const';
import { useCartCountStore } from '@/store/useCartCountStore';
import { useFirstScreenAB } from '@/hooks/abTest/firstScreen/useFirstScreenAb';
import { reportCatchError } from '@/utils/reportCatchError';
import { updateAddressCache } from '@/common/api/address/addressQueryV3Cache';
import { usePageContext } from '@/common/context/pageContext';
import ProductGuaranteeV2 from './components/ProductGuaranteeV2';
import { getEncryptionFormat } from '@/common/api-for-decode-base';
import { CouponHomePop } from './components/CouponHomePop';
import TopBar from '@/component/TopBar';
import { useParams } from 'react-router';
import './index.css';
import { openUrl } from '@/common/bridge/openUrl';
import SpecLinePop from './components/SpecLinePop';
import { GgPixelEnum, googlePixelLog } from '@/common/pixel';
import { getCookie } from '@kwr/utils-krn';
import { useLoginStore } from '@/component/LoginSdk/store/useLoginStore';

export const styles = StyleSheet.create({"tipsWrapper":{"height":"9.66183574879227rem","backgroundColor":"#FFF6F3","justifyContent":"center","marginBottom":"2.8985507246376816rem","paddingHorizontal":"4.5893719806763285rem"},"tipsText":{"fontSize":"2.8985507246376816rem"},"highLight":{"color":"#ff4906","fontWeight":"500","fontSize":"2.8985507246376816rem"}});

function DetailInner() {
    const props = useQuerys();
    const foldRatio = props.foldRatio || '';
    /** 商业化 click_id  */
    const clickid = (useQuery('click_id') as string) || '';
    const scene = SCENE.PRODUCT_DETAIL_OUTSIDE_WEB;
    const pageFromFe = useQuery('pageFromFe') as string;
    const cc = useQuery('cc') as string;
    const { encId: originEnCid } = useParams();
    const encId = decodeURIComponent(originEnCid);
    // 达人uid
    const sellerUserIdInQuery = useQuery('sellerUserId') as string;
    const sellerMerchantIdInQuery = useQuery('merchantId') as string;
    const extParams = useExtParamsObject();

    // 货架召回监控
    const retrievalInfo = useRetrievalInfo();

    const store = useDetailPageStore();
    const increaseCartCount = useCartCountStore(s => s.increaseCartCount);
    const getStore = store.getState;

    const baseInfo = useDetailPageStore(store => ({
        pageRawData: store.pageRawData,
        pageLoading: store.pageLoading,
        pageError: store.pageError,
        bottomAreaTipConfigLength: store.bottomAreaTipConfigLength,
        abTest: store.pageRawData.abTest,
        itemId: store.itemId,
    }));
    const { pageRawData, pageLoading, abTest, itemId } = baseInfo;

    const abInfo = useFirstScreenAB();
    const isEvaluationABTest = abInfo?.evaluation_display?.value;
    const isHitGalleryAb = abInfo?.buyer_gallery?.value;

    const { getBenifitsLogParams } = useShowProductBenifits(); // 是否展示商品权益
    const { detailABValueMap } = useABHandler();

    const isFromVideoAddon = useQuery('fromVideoAddon');

    useCheckMediaSource('Shop_KRN_Detail_Media_Source');
    const pageToNextTick = useNextTick([pageRawData]);

    useSetDetailBuyNum(pageRawData);
    const ext: string = useQuery('extParams') || '';
    const videoPhotoId = useQuery('photoId') as string;
    const { logger } = usePageContext();
    const eco_action_stack = useRef('');
    const benefit_spot = useRef('');
    const bottom_benefit_spot = useRef('');
    const tagCode = useRef('');
    const ENTRANCETYPE = useEntranceType();

    // 只曝光一次
    const sendPVFinshed = useRef(false);
    const sendPVStart = useRef(false);
    const sendPv = async () => {
        const _pageRawData = getStore().pageRawData;
        const _bigMarketingBanner = getStore().bigMarketingBanner;
        benefit_spot.current = getBenifitsLogParams(_pageRawData);
        bottom_benefit_spot.current = getBottomBenfitParams(_pageRawData);
        radar.event({
            name: 'DetailCustomLog',
            params: {
                pageName: 'DetailV2',
                optStage: `DetailPV1${sendPVFinshed.current}`,
                ...extParams,
            },
        });
        const isHalfPage = await isHalfByBridgeAsync();
        radar.event({
            name: 'DetailCustomLog',
            params: {
                pageName: 'DetailV2',
                optStage: `DetailPV2${sendPVFinshed.current}`,
                ...extParams,
            },
        });
        const pname = isHalfPage ? 216 : 217;
        await setPageDataTrace({ pname, rtype: 18, rid: itemId });
        radar.event({
            name: 'DetailCustomLog',
            params: {
                pageName: 'DetailV2',
                optStage: `DetailPV3${sendPVFinshed.current}`,
                ...extParams,
            },
        });
        const trace = await getAllLinkTrace();
        eco_action_stack.current = JSON.stringify(trace?.infos);
        radar.event({
            name: 'DetailCustomLog',
            params: {
                pageName: 'DetailV2',
                optStage: `DetailPV4${sendPVFinshed.current}`,
                ...extParams,
            },
        });
        radar.event({
            name: 'DetailCustomLog',
            params: {
                pageName: 'DetailV2',
                optStage: `DetailPV5${sendPVFinshed.current}`,
                ...extParams,
            },
        });
        const { itemTag = [], priceTag = [], merchantTag = [] } = _pageRawData.tagInfoAgg || {};
        const tags = [...itemTag, ...priceTag, ...merchantTag].filter(Boolean);
        tagCode.current = tags?.map(v => v.tagCode).join('-') || '';
        if (!sendPVFinshed.current) {
            sendPVFinshed.current = true;
            radar.event({
                name: 'DetailCustomLog',
                params: {
                    pageName: 'DetailV2',
                    optStage: 'sendPvWithActionStack',
                    ...extParams,
                },
            });

            // 统一腰带所有优惠信息上传,用逗号隔开
            const benefitSpotStr = (_bigMarketingBanner?.priceCalculator?.[_bigMarketingBanner?.defaultSkuId] || [])
                .map(item => {
                    return item.type;
                })
                .join(',');
            logger.sendPv({
                bundleId: 'Detail',
                componentName: 'Detail',
                page: 'PRODUCT_DETAILS',
                params: {
                    product_id: itemId,
                    page_type: getHalfByQuery(),
                    entrance_type: ENTRANCETYPE,
                    cc,
                    pageFromFe,
                    media_source: extParams.cT,
                    media_id: extParams.cId,
                    media_biz_source: extParams.cS,
                    eco_action_stack: eco_action_stack.current,
                    container: 'rn',
                    version: 'rn_v2',
                    benefit_spot: benefitSpotStr || benefit_spot.current,
                    bottom_benefit_spot: bottom_benefit_spot.current,
                    item_type: retrievalInfo?.itemType,
                    exptag: retrievalInfo?.expTag,
                    llsid: retrievalInfo?.llsid,
                    provider_source: retrievalInfo?.providerSource,
                    is_customer_reviews_mode: _pageRawData?.comments?.length ? 'TRUE' : 'FALSE',
                    tagCode: tagCode.current,
                    web_did: deviceId,
                    user_id: userId || 0,
                    country: currentCountry,
                    share_chain: window.location.href,
                    pwa_source: getQuery('pwa_source'),
                    is_kwai_tiny: 0,
                    referrer: document.referrer,
                    fReferrer: document.referrer,
                },
                coPage: getHalfByQuery(),
            });
            resolvePv();
        }
    };
    const sendPvWithoutActionStack = () => {
        sendPVFinshed.current = true;
        // 统一腰带所有优惠信息上传,用逗号隔开
        const _bigMarketingBanner = getStore().bigMarketingBanner;
        const benefitSpotStr = (_bigMarketingBanner?.priceCalculator?.[_bigMarketingBanner?.defaultSkuId] || [])
            .map(item => {
                return item.type;
            })
            .join(',');
        logger.sendPv({
            bundleId: 'Detail',
            componentName: 'Detail',
            page: 'PRODUCT_DETAILS',
            params: {
                product_id: itemId,
                page_type: getHalfByQuery(),
                entrance_type: ENTRANCETYPE,
                cc,
                pageFromFe,
                media_source: extParams.cT,
                media_id: extParams.cId,
                media_biz_source: extParams.cS,
                eco_action_stack: eco_action_stack.current,
                container: 'rn',
                version: 'rn_v2',
                benefit_spot: benefitSpotStr || benefit_spot.current,
                bottom_benefit_spot: bottom_benefit_spot.current,
                item_type: retrievalInfo?.itemType,
                exptag: retrievalInfo?.expTag,
                llsid: retrievalInfo?.llsid,
                provider_source: retrievalInfo?.providerSource,
                is_customer_reviews_mode: pageRawData?.comments?.length ? 'TRUE' : 'FALSE',
                tagCode: tagCode.current,
                web_did: deviceId,
                user_id: userId || 0,
                country: currentCountry,
                share_chain: window.location.href,
                pwa_source: getQuery('pwa_source'),
                is_kwai_tiny: 0,
                referrer: document.referrer,
                fReferrer: document.referrer,
            },
            coPage: getHalfByQuery(),
        });
        resolvePv();
        radar.event({
            name: 'DetailCustomLog',
            params: {
                pageName: 'DetailV2',
                optStage: 'sendPvWithoutActionStack',
                eco_action_stack: eco_action_stack.current,
                ...extParams,
            },
        });
    };

    useUnmount(() => {
        if (!sendPVFinshed.current && !pageLoading) {
            sendPvWithoutActionStack();
        }
    });

    const setStoreState = useDetailPageStore().setState;
    const getStoreState = useDetailPageStore().getState;
    const { sendItemInfoApiLog, resetStartTime } = usePerfLog(pageLoading);
    // 获取优惠券弹窗
    const getCouponPopUpData = useMemoizedFn(async ({ merchantId }) => {
        const couponData = await getCouponPopData({ merchantId, itemId });
        setStoreState({ couponData: couponData });
    });
    const firstApiLoaded = useRef(false);
    const fetchData = useMemoizedFn(async (options?: { init?: boolean; noSke?: boolean }) => {
        const { init = false, noSke = false } = options || {};
        if (!noSke) {
            setStoreState({ pageLoading: true });
        }
        try {
            const params = {
                encId,
                encryptedParam: JSON.stringify(getEncryptionFormat()), // 不能JSON.stringify, 预请求参数需要和这里一致
                sellerUserId: Number(sellerUserIdInQuery || 0),
                merchantId: Number(sellerMerchantIdInQuery || 0),
                extParams: ext,
                scene,
                photoId: videoPhotoId,
                autoFlush: !init,
            };
            const detailDataRes = await getDetailData(params).catch(err =>
                reportCatchError(err, {
                    position: 'fetchData-getDetailData',
                })
            );
            firstApiLoaded.current = true;

            radar.event({
                name: 'DetailCustomLog',
                params: {
                    pageName: 'Detail',
                    optStage: 'DetailEndApi',
                    ...extParams,
                },
            });
            sendItemInfoApiLog();
            if (init && getStoreState().pageLoading) {
                firstAPI();
                pageToNextTick.nextTick(() => {
                    firstScreen();
                    radar.event({
                        name: 'DetailCustomLog',
                        params: {
                            pageName: 'DetailV2',
                            optStage: 'DetailFirstScreen',
                            ...extParams,
                        },
                    });
                });
            }
            if (detailDataRes?.data) {
                const detailDataResData = detailDataRes.data;
                setStoreState(pre => ({
                    pageLoading: false,
                    pageRawData: detailDataRes.data ?? {},
                    showVideo: false, // 外投不展示 video
                    detailImageurls:
                        detailDataResData.templateImageUrls?.length &&
                        detailDataResData.templateImageUrls.length === detailDataResData.imageUrls.length
                            ? detailDataResData.templateImageUrls
                            : detailDataResData.imageUrls,
                    discountCoupon: detailDataResData.discountCoupon || [],
                    currentSku: detailDataResData?.skus?.length === 1 ? detailDataResData?.skus?.[0] : pre.currentSku,
                    itemId: detailDataResData.itemId,
                }));
                if (init && detailDataRes?.data?.merchantId) {
                    // 首次结束后，请求券弹窗
                    getCouponPopUpData({ merchantId: detailDataRes?.data?.merchantId });
                }
            } else {
                setStoreState({ pageLoading: false, pageError: true });
                radar.event({
                    name: 'DetailCustomLog',
                    params: {
                        pageName: 'Detail',
                        optStage: 'DetailApiError',
                        ...extParams,
                    },
                });
            }
            if (!sendPVStart.current) {
                radar.event({
                    name: 'DetailCustomLog',
                    params: {
                        pageName: 'DetailV2',
                        optStage: 'DetailStartSendPv',
                        ...extParams,
                    },
                });
                sendPVStart.current = true;
                sendPv();
            }
        } catch (error) {
            // 默认添加，防止try中语法问题被吃掉
            reportCatchError(error, {
                position: 'fetchData',
            });
            console.log('接口挂了', error);
            setStoreState({ pageLoading: false, pageError: true });
            radar.event({
                name: 'DetailCustomLog',
                params: {
                    pageName: 'Detail',
                    optStage: 'DetailApiError2',
                    ...extParams,
                },
            });
        }
    });
    // 防止首次进入页面时，iOS触发resume
    const { run: refreshData } = useDebounceFn(
        (options?: { init?: boolean; noSke?: boolean }) => {
            return fetchData(options);
        },
        {
            leading: true,
            trailing: false,
            wait: 500,
        }
    );

    // 请求接口数据
    useConstructor(() => {
        // T1
        whiteScreen();
        resetStartTime();
        refreshData({ init: true });
        // 提前预热是否有地址的接口
        setTimeout(() => {
            updateAddressCache();
        }, 3000);
        radar.event({
            name: 'DetailCustomLog',
            params: {
                pageName: 'DetailV2',
                optStage: 'DetailConstructor',
                ...extParams,
            },
        });
        googlePixelLog(GgPixelEnum.DETAIL_PV);
    });

    const refreshPage = () => {
        fetchData({ noSke: true });
    };

    // 更新商详页的mini coupon列表信息
    const updateMiniCouponInfo = useMemoizedFn(async () => {
        try {
            const params = {
                scene,
                encId,
                encryptedParam: JSON.stringify(getEncryptionFormat()), // 不能JSON.stringify, 预请求参数需要和这里一致
                sellerUserId: Number(sellerUserIdInQuery || 0),
                merchantId: Number(sellerMerchantIdInQuery || 0),
                extParams: ext,
            };
            const detailDataRes = await getDetailData(params).catch(err =>
                reportCatchError(err, {
                    position: 'updateMiniCouponInfo-getDetailData',
                })
            );
            if (detailDataRes?.data) {
                const detailDataResData = detailDataRes.data;
                setStoreState({
                    pageRawData: detailDataResData,
                    discountCoupon: detailDataResData.discountCoupon || [],
                    itemId: detailDataResData.itemId,
                });
            } else {
            }
        } catch (error) {
            console.log('接口挂了', error);
        }
    });

    useEffect(() => {
        // NativeModules.KRNBasic
        setStoreState({ fetchData, refreshCouponList: updateMiniCouponInfo });
    }, []);

    const skuSpecTypes = useRef([
        { label: $k18n({ id: 'k_226117', text: '规格' }), value: 1 },
        { label: $k18n({ id: 'k_226120', text: '颜色' }), value: 2 },
        { label: $k18n({ id: 'k_226121', text: '图案' }), value: 3 },
        { label: $k18n({ id: 'k_226122', text: '材质' }), value: 5 },
        { label: $k18n({ id: 'k_226123', text: '口味' }), value: 6 },
        { label: $k18n({ id: 'k_226124', text: '色号' }), value: 7 },
        { label: $k18n({ id: 'k_226125', text: '容量' }), value: 8 },
        { label: $k18n({ id: 'k_226126', text: '度数' }), value: 9 },
        { label: $k18n({ id: 'k_226127', text: '功效' }), value: 10 },
        { label: $k18n({ id: 'k_226128', text: '型号' }), value: 11 },
        { label: $k18n({ id: 'k_226129', text: '内存' }), value: 12 },
        { label: $k18n({ id: 'k_226130', text: '尺寸' }), value: 13 },
        { label: $k18n({ id: 'k_226131', text: '重量' }), value: 14 },
        { label: $k18n({ id: 'k_226132', text: '厚度' }), value: 15 },
        { label: $k18n({ id: 'k_226133', text: '适用肤质' }), value: 16 },
        { label: $k18n({ id: 'k_226134', text: '使用人群' }), value: 17 },
        { label: $k18n({ id: 'k_226135', text: '适用性别' }), value: 18 },
        { label: $k18n({ id: 'k_226136', text: '适用年纪' }), value: 19 },
        { label: $k18n({ id: 'k_226137', text: '适用季节' }), value: 20 },
        { label: $k18n({ id: 'k_226138', text: '货号' }), value: 21 },
        { label: $k18n({ id: 'k_226139', text: '尺' }), value: 22 },
        { label: $k18n({ id: 'k_226140', text: '款式' }), value: 23 },
    ]);
    const skuSpecTypesMap = useRef({});
    skuSpecTypes.current.forEach(item => {
        skuSpecTypesMap.current[item.value] = item.label;
    });

    const [visiblePop, setVisiblePop] = useState(false);
    const [visiblePopType, setVisiblePopType] = useState('buy'); // 规格弹窗 购买/加购

    const changeSpecPopupShow = show => {
        setVisiblePop(show);
    };

    // isNotAllImg = true 表示没有规格主图
    const isNotAllImg = !(pageRawData?.specs?.[0]?.itemSpecValues?.[0]?.imageUrl && pageRawData?.specs?.[0]?.itemSpecValues?.[0]?.imageUrl !== '');

    const closeSpec = (toast = '') => {
        changeSpecPopupShow(false);
        allowDefaultOutsideClick();
        // 关闭规格弹窗时是否需要toast
        if (toast) {
            console.log('toast', toast);
            Toast.show({
                text: $k18n(toast),
                duration: 1500,
            });
        }
    };

    const showSpec = (type = 'buy') => {
        setVisiblePopType(type);
        changeSpecPopupShow(true);
        ignoreOutsideClick();
        onClickContainerOutside(() => {
            closeSpec();
        });
    };

    const renderSke = useCallback((type: 'full' | 'part' = 'full') => {
        return <DetailSke type={type} />;
    }, []);
    const entranceType = ENTRANCETYPE;

    const renderErrPage = () => {
        return (
            <ViewVisible onVisible={() => logShowPageErr(0, pageRawData.itemId, entranceType)}>
                <KView rtlClassName={'detail-page-error'}>
                    <KImage rtlClassName={'detail-page-error-img'} source={imgEmpty} />
                    <KText rtlClassName={'detail-page-error-text'}>{$k18n('糟糕！商品找不到啦')}</KText>
                </KView>
            </ViewVisible>
        );
    };

    // 商品状态
    const pageActiveStatus = useMemo(() => {
        const country = pageRawData.saleCountry;
        console.log('currentCountry', currentCountryWithoutEars, pageRawData.itemId, detailABValueMap.ifProductDetailTransRegional);
        if (
            detailABValueMap.ifProductDetailTransRegional &&
            currentCountryWithoutEars &&
            (CountryNameList.IDN.includes(currentCountryWithoutEars) !== CountryNameList.IDN.includes(country) ||
                CountryNameList.BRA.includes(currentCountryWithoutEars) !== CountryNameList.BRA.includes(country))
        ) {
            radar.event({
                name: 'Trigger_Cover',
                params: {
                    userCountry: currentCountryWithoutEars || 'null',
                    productCountry: country,
                    productId: pageRawData.itemId,
                },
            });
            return -10;
        }
        // 总库存为0或者秒杀商品达到购买上限，都不可购买
        if (pageRawData.activeStatus === 2 && pageRawData?.activityInfo?.activityId && pageRawData?.activityInfo?.status === 4) {
            return 20;
        }
        // 库存小于最小起购件数，视为售罄
        if (
            !pageRawData?.extraInfo?.selfOperated &&
            (pageRawData.totalQuantity < pageRawData.minPurchase || pageRawData?.skus?.every(v => v.availableQuantity < pageRawData.minPurchase))
        ) {
            return 20;
        }
        if (pageRawData.activeStatus === 2 && pageRawData.totalQuantity !== 0) {
            return 2;
        }
        if (pageRawData.activeStatus === 1) {
            return 1;
        }
        if (pageRawData.activeStatus === 2 && pageRawData.totalQuantity === 0) {
            return 20;
        }
        return -1;
    }, [pageRawData]);
    // 加入购物车
    const { sellerMerchantId: sellerMerchantIdFromQuery, sellerUserId: sellerUserIdFromQuery } = useGetSellerParams();
    const postAddCartItem = async (sku, num = 1) => {
        // 商详返回引导加购若已点击加购则不会弹窗
        setStoreState(pre => ({ alertVisible: { ...pre.alertVisible, isClickedCart: true } }));
        // 未登陆需要登陆
        const res = await yoda.component.login({});
        if (res && +res.result === 1) {
            try {
                // 调用加入购物车接口
                const res = await postAddToCart({
                    itemId: itemId,
                    skuQuantity: num || 1,
                    merchantId: sku.merchantId,
                    skuId: sku.skuId,
                    // 埋点来源
                    mediaId: props.extParamsCustom?.cId || extParams.cId,
                    mediaSource: props.extParamsCustom?.cT || extParams.cT,
                    mediaDetailSource: props.extParamsCustom?.cS || extParams.cS,
                    sellerMerchantId: sellerMerchantIdFromQuery,
                    sellerUserId: sellerUserIdFromQuery,
                    recoDetail: {
                        expTag: retrievalInfo?.expTag,
                        llsid: retrievalInfo?.llsid,
                    },
                    clickid: clickid ?? '',
                }).catch(err =>
                    reportCatchError(err, {
                        position: 'postAddCartItem-postAddToCart',
                    })
                );
                if (res?.result === 1) {
                    radar.event({
                        name: 'SHOP_ADD_TO_CART',
                        params: {
                            skuId: sku.skuId,
                            media_source: props.extParamsCustom?.cT ?? extParams.cT,
                            sellerMerchantId: sellerMerchantIdFromQuery,
                            sellerUserId: sellerUserIdFromQuery,
                        },
                    });
                    closeSpec();
                    // 表明是新加购的商品，刷新红点数量+1
                    if (res.data.count !== 0) {
                        increaseCartCount();
                    }
                    let successToast = $k18n('添加成功');
                    // 加购数量等于最小起购数量时，toast提示“x件起购，已成功加购x件”
                    // TODO: 待产品补充多语言
                    if (pageRawData?.minPurchase > 1 && num === pageRawData?.minPurchase) {
                        successToast = $k18n({ id: 'k_450489', text: '{x}件起购，已成功加购{y}件', params: { x: num, y: num } });
                    }
                    Toast.show({ text: successToast, useModel: false });

                    return true;
                } else {
                    return false;
                }
            } catch (err) {
                return false;
            }
        }
    };

    // 短视频凑运费券场景只展示加购按钮
    const onlyShowAddToCartBtn = useMemo(() => {
        if (!isFromVideoAddon || isFromVideoAddon === 'undefined') {
            return false;
        }
        if (
            isFromVideoAddon &&
            detailABValueMap.addOnCouponType !== 0 &&
            detailABValueMap.addOnBtnType === 1 &&
            pageRawData.shippingFeeView &&
            pageRawData.shippingFeeView?.batchId &&
            !pageRawData.shippingFeeView?.reachedThreshold
        ) {
            const isSingleSku = pageRawData.skus.length === 1;
            const currentSku = getStoreState().currentSku;
            const buySku = isSingleSku ? pageRawData.skus[0] : currentSku;
            const buyQuantity = getStoreState().purchaseQuantity;

            // 多 sku 而且还没有选择规格，只能加购
            if (!isSingleSku && !currentSku.skuId) {
                return true;
            }

            // 购买总价 低于 运费券门槛，只能加购
            if ((buySku.activityPrice || buySku.salePrice) * buyQuantity < pageRawData.shippingFeeView.threshold) {
                return true;
            }
        }
        return false;
    }, [detailABValueMap.addOnCouponType, detailABValueMap.addOnBtnType, pageRawData]);

    const showGallery = isHitGalleryAb && getStore().galleryImgList?.length;
    const renderContentV2 = () => {
        const isNewUser = pageRawData?.newUser;
        return (
            <View
                style={{"flex":1,"height":"100%"}}>
                <CouponHomePop />
                <TopBar />
                <div className="detail-scroll-view">
                    <SwiperLineV2 />
                    <PriceLineV2 />
                    <DeliveryLineV2 pageRawData={pageRawData} itemId={+itemId} refreshPage={refreshPage} showCompany={abTest.shippingCompany} />
                    <ProductGuaranteeV2 itemId={pageRawData.itemId} />
                    <KView style={{ marginTop: isNewUser ? 0 : scaleW(8) }}>
                        <CommentLine hasBottomMargin={showGallery ? false : true} isEvaluationABTest={isEvaluationABTest} />
                        {showGallery ? <BuyerGalleryLine /> : null}
                    </KView>
                    <RenderDetail />
                </div>

                <SpecLinePopV2
                    isFrom={'detail'}
                    type={visiblePopType}
                    isPopVisible={visiblePop}
                    pageRawData={pageRawData}
                    closeSpec={closeSpec}
                    foldRatio={foldRatio}
                    ifUseDetailStore={true}
                    addCartItem={postAddCartItem}
                    showAfterCouponPrice={true}
                    pageActiveStatus={pageActiveStatus}
                    page={'detail'}
                    retrievalInfo={retrievalInfo}
                />
                <CouponLinePop />
                <OptionBar
                    isPopVisible={visiblePop}
                    isNotAllImg={isNotAllImg}
                    showCartStyle={pageRawData?.abTest?.bigPromotionButtonWarmUp ? 0 : 1}
                    showSpec={showSpec}
                    addCartItem={postAddCartItem}
                    pageActiveStatus={pageActiveStatus}
                    foldRatio={foldRatio}
                    shopIcon={pageRawData?.shopControl?.shopIcon || 'https://aws-static.kwai.net/udata/pkg/proweb/shop/c/dianpu.png'}
                    shopLogo={pageRawData?.shop?.imgUrl}
                    onlyShowAddToCartBtn={onlyShowAddToCartBtn}
                    retrievalInfo={retrievalInfo}
                />
            </View>
        );
    };

    const renderFun = () => {
        if (pageLoading) {
            return renderSke();
        }
        if (baseInfo.pageError) {
            return (
                <KView rtlClassName={'detail-page-content-with-height'}>
                    <TopBar />
                    {renderErrPage()}
                </KView>
            );
        }

        if (pageRawData && pageRawData.itemId) {
            return (
                // 为了把ios的底部按键让出 备用方案
                // style={isIOS && !isWeb ? { paddingBottom: inset?.bottom || 0 } : {}}
                <KView style={{"flex":1,"height":"100%"}}>{renderContentV2()}</KView>
            );
        }
    };

    return (
        <div style={{"height":"calc(100vh - env(safe-area-inset-bottom))"}}>
            <PageContext.Provider value={{ Styles }}>{renderFun()}</PageContext.Provider>
        </div>
    );
}

export default function Detail(props) {
    console.log('Detail Page Render ... ...');

    return (
        <UseCoudanInfoProvider>
            <DetailPageDataProvider>
                <RootSiblingParent>
                    <DetailInner {...props} />
                </RootSiblingParent>
            </DetailPageDataProvider>
        </UseCoudanInfoProvider>
    );
}
